<script setup lang="ts">
import { computed } from "vue"
import { cn } from "@/lib/utils"

export interface Props {
  /**
   * Icon name to display on the modal (Font Awesome format)
   * @example "fas fa-circle-info"
   */
  iconName?: string
  /**
   * The main body text shown inside the modal
   */
  body: string
  /**
   * Optional color theme (affects icon and background)
   * @default "mustard"
   */
  color?: "mustard"
}

const props = withDefaults(defineProps<Props>(), {
  iconName: "fas fa-circle-info",
  body: "",
  color: "mustard",
})

const iconColorClass = computed(() => {
  return {
    mustard: "text-mustard",
  }[props.color]
})

const bgColorClass = computed(() => {
  return {
    mustard: "bg-mustard-lighten-4",
  }[props.color]
})
</script>

<template>
  <div :class="cn('flex w-full items-center gap-3  p-4', bgColorClass)">
    <FaIcon
      :class="cn('h-5 w-5', iconColorClass)"
      :icon="props.iconName"
      aria-hidden="true"
    />
    <p class="text-sm font-light">
      {{ props.body }}
    </p>
  </div>
</template>
